module.exports = __webpack_public_path__ + "static/img/IMG_20240816_172118.da0d8df1.jpg";